import axios from "./axios";

export default {

    /**
     * Add groming related to patient in veterinary
     * @api {POST} veterinarygrooming
     */
     addPatientPrescription(data) {
        const options = {
            method: 'POST',
            url: 'medicalprescription',
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Get grooming related to patient
     * @param {string} patientID
     * @returns {Promise}
     */
     getPatientPrescription(patientID) {
        const options = {
            method: 'GET',
            url: `medicalprescription/${patientID}`,
            headers: {'content-type': 'application/json'},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getFilterPatientPrescription(data) {
        const options = {
            method: 'GET',
            url: `medicalprescription/filter`,
            headers: {'content-type': 'application/json'},
            params: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Update Grooming to Patient
     * @api {PUT} veterinarypatientgrooming
     */
     updatePatientPrescription(id, data) {
        const options = {
            method: 'PUT',
            url: `medicalprescription/${id}`,
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Delete Grooming related to Patient
     * @api {DELETE} veterinarypatientgrooming/:id
     */
     deletePatientPrescription(id) {
        const options = {
            method: 'DELETE',
            url: `medicalprescription/${id}`,
            headers: {'content-type': 'application/json'},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    }

}